module.exports = __webpack_public_path__ + "img/20200220234729360截图20200220234532639.9f99bbb7.jpg";